<template src="./App.html"></template>

<style lang="scss" src="./assets/_common/scss/_grid.scss"></style>
<style lang="scss" src="./assets/_common/scss/_mixins.scss"></style>
<style lang="scss" src="./assets/_common/scss/_universal.scss"></style>
<style lang="scss" src="./assets/_common/scss/_layout.scss"></style>
<style lang="scss" src="./assets/_common/scss/_breakpoints.scss"></style>
<style lang="scss" src="./App.scss"></style>

<script>
	import Header from '@/components/Header/Header';
	import Login from '@/components/Login/Login';
	import Notification from '@/components/Notification/Notification';
	import BlockNavigation from '@/components/BlockNavigation/BlockNavigation';
	import Slider from '@/components/Slider/Slider';
	import Teaser from '@/components/Teaser/Teaser';
	import List from '@/components/List/List';
	import Simple from '@/components/Simple/Simple';
	import Layer from '@/components/Layer/Layer';
	import Footer from '@/components/Footer/Footer';
	import ServiceCorner from '@/components/ServiceCorner/ServiceCorner';
	import { AdServiceWrapper } from '@/services/wrapper/adServiceWrapper';
	import { AdServiceHelper } from '@/services/helper/adServiceHelper';
	import { PermissionClientWrapper } from '@/services/wrapper/permissionClientWrapper';
	import { TrackingWrapper } from '@/services/wrapper/trackingWrapper';
	import { EventTrackingWrapper } from '@/services/wrapper/eventTrackingWrapper';
	import { Helper } from '@/services/helper/helper';
	import ContentWidthHelper from '@/services/helper/contentWidthHelper';

	export default {
		name: 'App',
		components: {
			'hp-teaser': Teaser,
			'hp-block-navigation': BlockNavigation,
			'hp-header': Header,
			'hp-login': Login,
			'hp-notification': Notification,
			'hp-slider': Slider,
			'hp-list': List,
			'hp-simple': Simple,
			'hp-footer': Footer,
			'hp-layer': Layer,
			'hp-service-corner': ServiceCorner
		},
		data () {
			return {
				teaserWidth: 300,
				colCount: 1,
				prevColCount: 0,
				dynamicMiddle: false,
				dynamicSides: false,
				fallback: false,
				sticky: false,
				gridRowGap: 30,
				gridColumnGap: 30,
				gridColumnGapMinWidth: 20,
				gridColumnGapActive: true,
				calculatedGridGapWidth: 30,
				gridSize: 1290,
				gridBorder: 30,
				gridBorderMinWidth: 10,
				calculatedGridBorderWidth: 30,
				selectedAd: 'none',
				sitebarWidth: '300',
				skyWidth: '130',
				superbannerSitebarMinWidth: '120',
				homeframeSkyWidth: '120',
				homeframeSitebarMinWidth: '160',
				adOverlap: true,
				topName: 'top',
				middleName: 'middle',
				rightName: 'right',
				leftName: 'left',
				minCols: 2,
				maxCols: 4,
				minAdWidth: 0,
				possibleContentWidth: 0,
				isResponsiveGridBorder: false,
				initialData: this.$initialData,
				urlParams: new URLSearchParams(window.location.search)
			};
		},
		watch: {
			selectedAd: function (val) {
				document.querySelector('body').setAttribute('data-ad-type', val);
				ContentWidthHelper.setColCase();
			}
		},
		methods: {
			touchDetector () {
				return !!('ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
			},
			getAds () {
				if (window.initialData.serviceResponse.response.right?.width) {
					this.superbannerSitebarMinWidth = window.initialData.serviceResponse.response.right.width;
				}

				AdServiceWrapper.init('service', undefined, this.colCount);
				this.selectedAd = AdServiceWrapper.serviceResponse.response.type;

				AdServiceHelper.listenEvent('initialize.end', () => {
					AdServiceWrapper.logVersion();
				});

				/*
	               const makeBiddingAds = () => {
	                   const availableResponse = this.$initialData.availableResponse;
	                   PrebidWrapper.init();
	                   if (response.rtb) {
	                       PrebidWrapper.startBidding('initial');
	                   }

	                   if (availableResponse.placements.box_1 && availableResponse.placements.box_1.rtb) {
	                       PrebidWrapper.startBidding('box_1');
	                   } else {
	                       AdServiceWrapper.makeAd('box_1');
	                   }

	                   for (let i = 1; i <= 9; i++) {
	                       if (availableResponse.placements['box_' + i] && availableResponse.placements['box_' + i].rtb) {
	                           PrebidWrapper.startBidding('box_' + i);
	                       } else {
	                           AdServiceWrapper.makeAd('box_' + i);
	                       }
	                   }
	               };
	            */

				const makeBoxAds = () => {
					for (let i = 1; i <= 10; i++) {
						AdServiceWrapper.makeAd('box_' + i);
					}
				};

				const makeEventAds = (response) => {
					const parts = ['top', 'middle', 'left', 'right'];
					for (let part of parts) {
						const responsePart = response[part];
						if (responsePart) {
							let fillMe = '';
							let fallbackWidth = 0;
							let fallbackHeight = 0;

							// middle fallback is always billboard
							if (part === 'middle') {
								fallbackWidth = 970;
								fallbackHeight = 250;
							}

							if (AdServiceWrapper.fallback) {
								this.fallbackWidth = true;
								if (responsePart.fallbackWidth) {
									fallbackWidth = responsePart.fallbackWidth;
								}
								if (responsePart.fallbackHeight) {
									fallbackHeight = responsePart.fallbackHeight;
								}

								if ((part === 'top' || part === 'middle') && responsePart.fallback?.['column' + this.colCount + 'Ad']) {
									fillMe = responsePart.fallback?.['column' + this.colCount + 'Ad'];
									const takeSmaller = (currentCols) => {
										const uimTag = AdServiceWrapper.getUIMTag(part, fallbackWidth, fallbackHeight);
										let takeMe = responsePart.fallback['column' + currentCols + 'Ad'];
										if (!takeMe) {
											takeMe = responsePart.fallback['column' + (currentCols - 1) + 'Ad'];
										}
										return uimTag + takeMe;
									};

									document.addEventListener(
										'colCountChanged',
										(colChangeEvent) => {
											const colCase = colChangeEvent.detail.colCount;
											const takeMe = takeSmaller(colCase);
											AdServiceWrapper.queueHtml(part, uimTag + takeMe, true);
										},
										false
									);

									fillMe = takeSmaller(this.colCount);
								} else {
									fillMe = responsePart.fallback;
								}
							} else {
								if ((response.type === 'bridge' || response.type === 'flagship' || response.type === 'cinematic' || response.variant === 'dynamic') && part === 'middle') {
									this.dynamicMiddle = true;
								}
								if (response.skyVariant !== undefined && (response.skyVariant.length === 0 || response.skyVariant === 'dynamic')) {
									this.dynamicSides = true;
								}
								fillMe = responsePart.ad;
							}

							const uimTag = AdServiceWrapper.getUIMTag(part, fallbackWidth, fallbackHeight);
							AdServiceWrapper.queueHtml(part, uimTag + fillMe, false, part);
						}
					}
				};

				const makeEventAdblockerFallbackAds = () => {
					const callTop = ['wallpaper', 'homeframe'].includes(this.selectedAd);
					const callMiddle = ['billboard', 'flagship', 'bridge', 'cinematic'].includes(this.selectedAd);
					const callLeft = ['double-sitebar', 'homeframe'].includes(this.selectedAd);
					const callRight = ['double-sitebar', 'sitebar', 'wallpaper', 'homeframe'].includes(this.selectedAd);

					if (callTop) {
						// In adblocker case we have no top position
						const topAd = document.querySelector('[data-ac="top"]');
						topAd?.parentElement?.removeChild(topAd);

						ContentWidthHelper.data.minCols = 2; // 2 cols min cause we now have just a sitebar
						ContentWidthHelper.data.superbannerSitebarMinWidth = this.sitebarWidth; // overwriting old width value with sitebar value
						ContentWidthHelper.setOutsideAdSize(); // call function to make the new width values active
						ContentWidthHelper.setColCase(); // trigger for possible new colCase
					}

					if (callMiddle) {
						ContentWidthHelper.data.minCols = 3; // 3 cols minimum because be only have a billboard in adblock case
						ContentWidthHelper.setColCase(); // trigger for possible new colCase

						// TODO: refactoring, move to another place where it suits better
						// fixes "jumping" billboard
						const middleServiceSlot = document.querySelector('[data-service-slot="middle"]');
						if (middleServiceSlot) {
							middleServiceSlot.style.opacity = '0';
						}

						AdServiceHelper.listenEvent('ad.useiframecss.done', () => {
							if (middleServiceSlot) {
								middleServiceSlot.style.opacity = null;
							}
						});
						AdServiceWrapper.makeAd('middle', true);
					}

					if (callLeft) {
						AdServiceWrapper.makeAd('left', true);

						if (this.selectedAd === 'homeframe') {
							const leftAd = document.querySelector('[data-container="left"]');
							leftAd?.parentElement?.removeChild(leftAd);

							this.selectedAd = 'sitebar'; // so we get the right CSS from _grid.scss otherwise there would be a 120px blank space on the left side
						}
					}

					if (callRight) {
						AdServiceWrapper.makeAd('right', true);
					}

					document.querySelector('#acColor')?.remove(); // removes the style container given by the BE so we are back to our default colors
				};

				const makeRotationAds = (response, isTrackingBlocker) => {
					const callMiddle = this.selectedAd === 'billboard';
					const callRight = this.selectedAd === 'sitebar';

					if (callMiddle) {
						if (isTrackingBlocker) {
							AdServiceWrapper.makeAd('middle', true);
						} else {
							AdServiceWrapper.queueHtml('middle', response.ad, false, response.type);
						}
					}

					if (callRight) {
						if (isTrackingBlocker) {
							AdServiceWrapper.makeAd('right', true);
						} else {
							AdServiceWrapper.queueHtml('right', response.ad, false, response.type);
						}
					}
				};

				const callAfterAdBlockerDect = (isAdBlocker) => {
					if (!isAdBlocker) {
						if (window.initialData.serviceResponse.response.bg) {
							const { clickurl } = window.initialData.serviceResponse.response.bg;

							clickurl &&
								document.querySelectorAll('[data-ac], [data-container]').forEach((element) => {
									element.style.cursor = 'pointer';
									element.addEventListener('click', (event) => {
										window.open(clickurl, '_blank');
									});
								});
						}

						const callAfterTrackingBlockerDetected = (isTrackingBlocker) => {
							AdServiceWrapper.incrementAc();
							this.fallback = AdServiceWrapper.showFallback();
							const response = AdServiceWrapper.serviceResponse.response;

							if (!response.rtb) {
								if (response.top || response.middle || response.left || response.right) {
									if (isTrackingBlocker && response.blockClean) {
										makeEventAdblockerFallbackAds();
									} else {
										makeEventAds(response, isTrackingBlocker);
									}
								} else {
									makeRotationAds(response, isTrackingBlocker);
								}
							}

							AdServiceWrapper.makePartnerlinks();
							makeBoxAds();
							AdServiceWrapper.makeVorteilswelt();
							AdServiceWrapper.makeAd('tam');
						};

						AdServiceWrapper.checkTrackingBlocker(callAfterTrackingBlockerDetected);
					} else {
						this.fallback = true;
						makeEventAdblockerFallbackAds();
						AdServiceWrapper.makePartnerlinks();
						makeBoxAds();
						AdServiceWrapper.makeVorteilswelt();
						AdServiceWrapper.makeAd('tam');
					}
				};

				AdServiceWrapper.checkAdBlocker(callAfterAdBlockerDect);
			},
			getPermissionScripts () {
				let stage = window.PageConfig.stage.indexOf('qa') > -1 ? 'qa' : window.PageConfig.stage;

				if (stage === 'dev' || stage === 'local') {
					stage = 'qa';
				} else if (stage === 'prelive') {
					stage = 'live';
				}

				let permissionClientBaseURL = '//dl.' + window.SiteInfo.brandShort + '.' + window.SiteInfo.tld + '/permission/' + stage + '/v1/ppp/js/';
				let permissionClientURL = permissionClientBaseURL + 'permission-client.js';
				let permissionClientCompatURL = permissionClientBaseURL + 'permission-client-compat.js';

				Helper.addScript(permissionClientURL, () => {
					Helper.addScript(permissionClientCompatURL, () => {
						new PermissionClientWrapper();
					});
				});
			},
			getAdserviceScripts () {
				let stage = window.PageConfig.stage.indexOf('qa') > -1 ? 'qa' : window.PageConfig.stage;
				let jsFile = '/service-2.min.js';

				if (stage === 'local') {
					jsFile = './js' + jsFile;
				} else {
					jsFile = '/js' + jsFile;
				}

				let jsBasePath = document
					.querySelector('script[src*="homepage.bundle.js"]')
					.getAttribute('src')
					.split('/')
					.slice(0, -1)
					.join('/');

				let serviceJsPath = jsBasePath + jsFile;
				Helper.addScript(serviceJsPath, () => {
					this.getAds();
				});
			}
		},
		beforeCreate () {
			// disable the ability to kill the hp via an ad
			document.write = (str) => {
				if (window.location.href.includes('local')) {
					console.log('document.write ' + str);
				}
			};
			document.open = () => {
				if (window.location.href.includes('local')) {
					console.log('document.open');
				}
			};
			document.close = () => {
				if (window.location.href.includes('local')) {
					console.log('document.close');
				}
			};
		},
		created () {
			ContentWidthHelper.init(this._data);

			window.AdService = window.AdService || [];
			this.selectedAd = document.querySelector('body').getAttribute('data-ad-type') || window.initialData?.serviceResponse?.response?.type || '';

			if (window.PageConfig.stage.includes('live') || (!window.PageConfig.stage.includes('live') && this.urlParams.get('colcalc') !== 'false')) {
				ContentWidthHelper.setContentMinWidth();
				ContentWidthHelper.checkResponsiveGrid();

				window.addEventListener('resize', ContentWidthHelper.setColCase);
				ContentWidthHelper.setColCase();
			} else {
				console.log('col calculation off');
			}

			document.documentElement.style.setProperty('--justify-grid-content', 'center');
			document.documentElement.style.setProperty('--screen-touchable', this.touchDetector());

			const response = window.initialData.serviceResponse.response;

			if (response.variant === 'sticky' || response.type === 'sitebar' || response.type === 'double-sitebar' || response.type === 'flagship' || response.type === 'wallpaper' || response.type === 'homeframe') {
				this.sticky = true;
			}

			if ((response.type === 'billboard' && response.variant !== 'dynamic') || response.type === 'wallpaper') {
				ContentWidthHelper.data.minCols = 3;
			}

			if (!window.SiteInfo) {
				window.SiteInfo = {};
			}

			window.SiteInfo.brand = process.env.VUE_APP_BRAND;

			if (location.hostname !== 'localhost') {
				const regex = /\.([^.]+?)$/;
				window.SiteInfo.tld = regex.exec(location.hostname)[1];
			}
			// get Top Level Domain
			if (window.SiteInfo.tld === 'lan' || location.hostname === 'localhost') {
				if (window.SiteInfo.brand === 'gmx') {
					window.SiteInfo.tld = 'net';
				} else {
					window.SiteInfo.tld = 'de';
				}
			}

			window.SiteInfo.brandShort = '';
			switch (window.SiteInfo.brand) {
				case 'webde':
					window.SiteInfo.brandShort = 'web';
					window.SiteInfo.portalName = 'webde';
					break;
				case 'gmx':
					window.SiteInfo.brandShort = 'gmx';
					window.SiteInfo.portalName = 'gmx' + window.PageConfig.country;
					break;
				case 'einsundeins':
					window.SiteInfo.brandShort = '1und1';
					window.SiteInfo.portalName = '1und1';
					break;
				default:
					window.SiteInfo.brandShort = 'localhost';
			}

			if (window.PageConfig.stage.includes('live') || (!window.PageConfig.stage.includes('live') && this.urlParams.get('tracking') !== 'false')) {
				window.Tracking = new TrackingWrapper();
				new EventTrackingWrapper();
			} else {
				console.log('tracking off');
			}
		},
		mounted () {
			if (window.PageConfig.stage.includes('live') || (!window.PageConfig.stage.includes('live') && this.urlParams.get('lazyloading') !== 'false')) {
				// adds lazyloading to all teaser images (except ads)
				const supportsLazyLoad = 'loading' in HTMLImageElement.prototype;

				if (!supportsLazyLoad) {
					document.addEventListener('DOMContentLoaded', function () {
						if ('IntersectionObserver' in window) {
							let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
								entries.forEach((entry) => {
									if (entry.isIntersecting) {
										let lazyImage = entry.target;

										if (lazyImage.dataset.src) {
											lazyImage.src = lazyImage.dataset.src;
										}

										lazyImageObserver.unobserve(lazyImage);
									}
								});
							});

							document.querySelectorAll('img[loading="lazy"]').forEach((lazyImage) => {
								lazyImageObserver.observe(lazyImage);
							});
						}
						// Else we have a problem... no images as result
						// BUUUUT this should never ever happen, because the browser support for IntersectionObserver is way better than loading on HTMLImageElement
					});
				} else {
					document.querySelectorAll('img[loading="lazy"]').forEach((image) => {
						if (image.dataset.src) {
							image.src = image.dataset.src;
						}
					});
				}
			} else {
				console.log('lazyloading off');
			}

			this.$nextTick(() => {
				document.querySelector(':root').style.setProperty('--scrollbar-width', window.innerWidth - document.body.offsetWidth + 'px');
			});

			this.$nextTick().then(() => {
				let event = new CustomEvent('pageReady', { bubbles: true, cancelable: true, detail: { source: 'App.vue' } });
				document.dispatchEvent(event);
			});

			// closure for scope
			(() => {
				const _this = this;
				window.addEventListener('load', (e) => {
					if (window.PageConfig.stage !== 'live') {
						console.log(new Date().getTime() - window.startupTS + 'ms since JS start');
						console.log(new Date().getTime() - window.startupTSVue + 'ms since VueJS start');
					}

					if (window.PageConfig.stage.includes('live') || (!window.PageConfig.stage.includes('live') && this.urlParams.get('permissionlayer') !== 'false')) {
						_this.getPermissionScripts();
					} else {
						console.log('permissionlayer off');
					}

					if (window.PageConfig.stage.includes('live') || (!window.PageConfig.stage.includes('live') && this.urlParams.get('ads') !== 'false')) {
						_this.getAdserviceScripts();
					} else {
						console.log('ads off');
					}
				});
			})();
		}
	};
</script>
